export default __webpack_public_path__ + "static/wizard-9506d11f64811b06f0afe38b920fa5bd.svg";